'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { IBaseSelect, LFBaseSelect } from './LFBaseSelect';
import { DropdownCaret } from '@components/icons';
import { IBaseOption, defaultNumberDropdownStyles } from './utils';
import { components as RSComponents, DropdownIndicatorProps, ControlProps, GroupBase, StylesConfig, Props as RSProps } from 'react-select';
export type IPlainSelectProps<T extends IBaseOption> = Omit<IBaseSelect<T, false>, 'useAsync'>;
const DropdownIndicator = props => {
  const $ = _c(5);
  let t0;
  if ($[0] !== props.isDisabled) {
    t0 = !props.isDisabled ? <DropdownCaret className="w-6 text-grey" /> : " ";
    $[0] = props.isDisabled;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props || $[3] !== t0) {
    t1 = <RSComponents.DropdownIndicator {...props}>{t0}</RSComponents.DropdownIndicator>;
    $[2] = props;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
const ControlComponent = observer(<T extends IBaseOption,>(props: ControlProps<T, false, GroupBase<T>>) => <label className={`
        block w-max rounded-l-md border-none
        ${props.selectProps.id !== 'multiselect' ? 'rounded-r-md' : ''}
        ${props.selectProps.id !== 'no-bg-dropdown' ? 'bg-spindle' : 'bg-white'}
      `}>
      <RSComponents.Control {...props} />
    </label>);
export const LFPlainSelect = observer(<E extends IBaseOption,>({
  customDropdownStyles,
  ...rest
}: IPlainSelectProps<E>) => {
  // Merge dropdown styles
  const finalStyles: StylesConfig<E, false, GroupBase<E>> = customDropdownStyles ? customDropdownStyles(defaultNumberDropdownStyles) : defaultNumberDropdownStyles;

  // Configure custom components
  const customComponents: Partial<RSProps<E, false>['components']> = {
    Control: ControlComponent,
    DropdownIndicator,
    IndicatorSeparator: () => null
  };
  return <div className="h-full w-fit">
        <LFBaseSelect<E, false> customDropdownStyles={() => finalStyles} customComponents={customComponents} useAsync={false} {...rest} />
      </div>;
});